import React, { useEffect } from 'react'


export const PageSection = ({ children, width = "normal" }) => {


    return (
        <section className="page-section" >
            <div className={`page-section__inner page-section__inner--${width}`}>
                {children}
            </div>
        </section>
    )
}
